import { FC } from "react";
import { PageHeader } from "../../components/PageHeader";
import { HostedTools } from "../../modules/HostedTools";
import "./style.css";

export const HostedToolsPage: FC = () => {
  return (
    <div className="hosted-tools-page">
      <PageHeader
        header="Hosted tools"
        description="Connector tools, search widgets and other pages hosted on the demo static website"
      />
      <HostedTools />
    </div>
  );
};
